<template>
	<div>

		<div v-scroll="onScroll">

			<v-list grey-back two-line nopadding v-if="listItemObject.totalCount">

				<div white-background v-for="(item, index) in listItemObject.items" :key="index" :class="{'margin-top-ten':index!=0}" :id="'item_'+item.transactionId">
					<v-list-tile class="right-subtitle-tile" @click="fn_itemClick(item, index)">
					    <v-list-tile-content>
					      <v-list-tile-title class="mb-1">{{fn_transactionName(item.transactionListId)}}</v-list-tile-title>
					      <v-list-tile-sub-title>
					      	<span v-if="item.mergeTransactionNumber" class="primary-color">{{item.mergeTransactionNumber}}</span>
					      	{{item.mergeTransactionNumber ? ' | ' : ''}}
					      	{{fn_transactionDate(item.transactionListId, item.transactionDate)}}
					      </v-list-tile-sub-title>
					    </v-list-tile-content>

					    <v-list-tile-action align-flex-end>
					    	<div class="warning-label" v-if="!item.status">Cancelled</div>
					    	<div v-else></div>
					    	<div>&#8377; {{$root.numberToLocale(Math.abs(item.roundedAmount))}}</div>
					    </v-list-tile-action>
					</v-list-tile>

					<v-divider v-if="item.invoiceTemplate"></v-divider>
					<div right-align style="padding:2px 6px" v-if="item.invoiceTemplate">
						<v-btn nomargin icon flat @click="bindInvoiceTemplate('sharewhatsapp', item)"><img src="../../../../../assets/icon_whatsapp.svg" style="width:20px" alt="whatapp_icon"></img></v-btn>
						<v-btn nomargin icon flat @click="bindInvoiceTemplate('share', item)"><v-icon font20>share</v-icon></v-btn>
				    	<v-btn nomargin icon flat @click="bindInvoiceTemplate('print', item)"><v-icon font20>print</v-icon></v-btn>
				    	<v-btn nomargin icon flat @click="preview(item, fn_transactionName)">
				    		<img src="../../../../../assets/icon_preview_black.svg" style="width:20px" alt="preview_icon"></img>
				    	</v-btn>
				    </div>
				</div>


			</v-list>

			<div class="pa-3 center-align light-opacity-color" v-if="!listItemObject.totalCount && !loadMore">No activity!</div>

			<div padding-all-16 center-align v-if="loadMore">
				<v-progress-circular indeterminate color="primary"></v-progress-circular>
			</div>
		</div>
	</div>
</template>

<script>

const transactionForms = require('../../../../../config.js').configs.transactionForms;

	export default{
		props:['expenseCategoryId', 'preview', 'bindInvoiceTemplate'],
		data(){
			return{
				toolbarTitle:null,
				listItemObject:{"items":[], "totalCount":0},
				searchValue:'',
				infiniteId: +new Date(),
				startIndex:0,
				scrollPositionTop:0,
				selectedItemId:null,
				loadMore: false,
				showPlaceHolder:false
			}
		},
		methods:{

			fn_transactionDate: function(listId, transactionDate){
				if(listId != 40003){
					return this.$moment(transactionDate).format('DD-MMM-YYYY');	
				}
				else{
					return this.$moment(this.$root.CurrentBusiness.OpeningDate).format('DD-MMM-YYYY');		
				}
			},

			onScroll: function(event){
				var element = event.target;
			    if (element.documentElement.scrollHeight - element.documentElement.scrollTop - 20 <= element.documentElement.clientHeight)
			    {
			        console.log('scrolled');
			        if(this.listItemObject.items.length < this.listItemObject.totalCount){
			        	this.fn_loadItems();
			        }
			    }
			},

			fn_transactionName: function(transactionListId){
				for(let i=0; i<transactionForms.length; i++){
					if(transactionForms[i].id == transactionListId){
						return transactionForms[i].title;
					}
				}
			},

			fn_itemClick: function (item, index) {
				let obj = {};
				obj.itemId = null;
				obj.lastScrollPos = window.pageYOffset;
				obj.itemIndex = index + 1;
				localStorage.setItem("transaction_items_state", JSON.stringify(obj));
				this.$root.fn_navigateToDisplayView(item.transactionListId, item.transactionId);
			},

			fn_loadItems: function() {
				this.loadMore = true;
		    	let filterObject = {};
				filterObject.expenseCategoryId = this.expenseCategoryId;
				filterObject.transactionListId = [20005];
				filterObject.limit = 50;
				filterObject.startIndex = this.startIndex;
				filterObject.search = '';
				this.loading = true;

				let pageState = null;
				if(localStorage.getItem("transaction_items_state")){
					pageState = JSON.parse(localStorage.getItem("transaction_items_state"));
					filterObject.limit = 50 - (pageState.itemIndex % 50) + pageState.itemIndex;
				}

				console.log(JSON.stringify(filterObject));

				let self = this;
				this.getItems("ExpenseCategoryActivities", filterObject, 
					{
						onSuccess: function (response) {
							console.log(response);
							let responseJson = JSON.parse(response);
							self.listItemObject.totalCount = responseJson.totalCount;

							for(let i in responseJson.items){
								let itemIndex = self.listItemObject.items.findIndex(item => item.transactionId==responseJson.items[i].transactionId);

								if(itemIndex==-1){
									self.listItemObject.items.push(responseJson.items[i]);	
								}
							}

							console.log(pageState);

							if(pageState && !pageState.itemId){
								setTimeout(function(){
									let scrollOptions = {"duration":0, "offset":0, "easing":"linear"};
									self.$vuetify.goTo(pageState.lastScrollPos, scrollOptions);
									localStorage.removeItem("transaction_items_state");
								},100);
							}

							if(localStorage.getItem("scroll_top")){
								setTimeout(function(){
									let scrollOptions = {"duration":0, "offset":0, "easing":"linear"};
									self.$vuetify.goTo(0, scrollOptions);
								},100);
							}

							self.startIndex = self.listItemObject.items.length;
							self.loadMore = false;

							setTimeout(function(){
								self.showPlaceHolder = true;
							},300);
						},
						onError: function (error) {
							console.log(error);
							self.loadMore = false;
						}
					}
				)
		    }


		},
		mounted: function(){
			this.fn_loadItems();
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/masters/forms/expense_categories/display_tabs/activity.vue